import { RouterModule, Routes } from '@angular/router';

import { DayTimeSelectorPage } from './day-time-selector.page';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: '',
    component: DayTimeSelectorPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DayTimeSelectorPageRoutingModule {}
